import React from 'react';
import {useToasts} from 'features/notifications/useToasts';
import {getErrors} from 'redux/common';

type Props = {
   url: string;
   setError?: (err: any) => void;
   setLoading?: (loading: boolean) => void;
   onFailure?: (err: any) => void;
};
export const useHandleApiErrorCallback = () => {
   const {addToast} = useToasts();

   const handler = React.useCallback(
      ({url, setError, setLoading, onFailure}: Props) => (e: Response) => {
         getErrors(e, url).then(({message, error}) => {
            console.debug(message);

            setError?.(error);
            setLoading?.(false);
            onFailure?.(error);
            addToast(message, {appearance: 'error'});
         });
      },
      [addToast]
   );

   return handler;
};
